/*
 * Project: bellcloud
 * File: packages/protocol/lite/fn_maintenance.ts
 * Author: SWAN
 * Created: 2025-07-21 17:03:00
 * Description:
 */
import type { FunctionParameter } from '../fns';

export const params_maintenance: Record<number, FunctionParameter[]> = {
  0x02: [
    {
      name: 'first_use_date_sensor',
      type: 'au16',
      bytes: 10,
      comment: 'First use date of sensor, days since 2023.01.01',
      format: 'array_date_from_basedate',
    },
    {
      name: 'sensor_running_time',
      type: 'au16',
      bytes: 10,
      comment: 'Days since first use of sensor',
      format: 'array_number',
    },
    {
      name: 'first_use_date_battery',
      type: 'au16',
      bytes: 10,
      comment: 'First use date of battery, days since 2023.01.01',
      format: 'array_date_from_basedate',
    },
    {
      name: 'battery_running_time',
      type: 'au16',
      bytes: 10,
      comment: 'Days since first use of battery',
      format: 'array_number',
    },
    {
      name: 'activation_date',
      type: 'au16',
      bytes: 10,
      comment: 'Activation date of device, days since 2023.01.01',
      format: 'array_date_from_basedate',
    },
    {
      name: 'device_running_time',
      type: 'au16',
      bytes: 10,
      comment: 'Days since activation of device',
      format: 'array_number',
    },
  ],

  0x03: [
    {
      name: 'timestamp',
      type: 'u32',
      bytes: 4,
      comment: 'Seconds since 2023.01.01; used to update system time',
      format: 'date_seconds_from_basedate',
    },
    {
      name: 'sensor_type',
      type: 'au8',
      bytes: 5,
      comment: 'Sensor type (255 if not replaced)',
      format: 'enum_sensors',
    },
  ],

  0x04: [{ name: 'result', type: 'u8', bytes: 1, comment: '0: Fail, 1: Pass', format: 'bool' }],

  0x05: [
    {
      name: 'timestamp',
      type: 'u32',
      bytes: 4,
      comment: 'Seconds since 2023.01.01; used to update system time',
      format: 'date_seconds_from_basedate',
    },
  ],

  0x06: [{ name: 'result', type: 'u8', bytes: 1, comment: '0: Fail, 1: Pass', format: 'bool' }],
};
